import { CoreIssue } from '../types';

export abstract class CoreIssueService {
	public abstract config(): Promise<null>;
    public abstract getAll(): Promise<CoreIssue[]>;
    public abstract getCoreIssue(id: number): Promise<CoreIssue>;
}
